/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface IDigitalMagazine {
  id?: number;
  cover?: string;
  image?: string;
  articleTitle?: string;
  articleContent?: string;
  title?: string;
  name?: string;
  agreement?: string;
  fileUrl?: string;
  pdf?: string;
  file?: string;
  link?: string;
  referenceMonth?: number;
  referenceYear?: number;
  issueNumber?: string;
  [key: string]: any;
}

interface IMagazineContext {
  magazine: IDigitalMagazine | null;
  openMagazine: (magazine: IDigitalMagazine) => void;
  closeMagazine: () => void;
}

const MagazineContext = createContext<IMagazineContext>({
  magazine: null,
  openMagazine: () => {},
  closeMagazine: () => {},
});

export function MagazineProvider({ children }: PropsWithChildren) {
  const [magazine, setMagazine] = useState<IDigitalMagazine | null>(null);

  return (
    <MagazineContext.Provider
      value={{
        magazine,
        openMagazine: (mag) => setMagazine(mag),
        closeMagazine: () => setMagazine(null),
      }}
    >
      {children}
    </MagazineContext.Provider>
  );
}

export function useOpenMagazine() {
  return useContext(MagazineContext);
}
